import { render, staticRenderFns } from "./workflow-task-alert.vue?vue&type=template&id=7fdbf13e&scoped=true&functional=true"
import script from "./workflow-task-alert.vue?vue&type=script&lang=js"
export * from "./workflow-task-alert.vue?vue&type=script&lang=js"
import style0 from "./workflow-task-alert.vue?vue&type=style&index=0&id=7fdbf13e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "7fdbf13e",
  null
  
)

export default component.exports